<template>
  <div class="poi-card flex">
    <div class="category">
      <i :class="`icon-${categoryIcon}`"></i>
      <span>{{ categoryName }}</span>
    </div>
    <div class="place text-bold">
      {{ placeName }}
    </div>
    <div class="address-top">
      {{ address }}
    </div>
    <div class="address-bottom">
      {{ city }}, {{ state }} {{ zip }}
    </div>
  </div>
</template>

<script>
  export default {
      name: 'PoiCard',
      props: {
          categoryName: {
            type: String,
            required: true,
          },
          categoryIcon: {
            type: String,
            required: true,
          },
          placeName: {
            type: String,
            required: true,
          },
          address: {
            type: String,
            required: true,
          },
          city: {
            type: String,
            required: true,
          },
          state: {
            type: String,
            required: true,
          },
          zip: {
            type: String,
            required: true,
          },
      },
  };
</script>

<style lang="scss">
  @use "~@/common/scss/base/_mixins.scss" as *;
  .poi-card {
    flex-direction: column;
    padding: 1rem;
    gap: 0.25rem;
    border-radius: 0.5rem;
    border: 1px solid #ddd;
    @include f7();

    .category {
      display: flex;
      gap: 0.25rem;
    }

    >:not(.place) {
      color: var(--color-7);
    }
  }
</style>